/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';
const Dynpack = require('od-apps/app.dynpack');
var trackingUtils = require('../utils/tracking.utils');
var SHARE_EMAIL_UTM = 'share_dp';
var SHARE_EMAIL_TEMPLATE = 'share.deeplink.dynpack';
var UTM_PARAMS = $.param({
    utm_medium: 'crm',
    utm_source: 'sg',
    utm_campaign: 't',
    utm_term: SHARE_EMAIL_UTM,
    mktportal: 'T',
});
var SOCIAL_LINK = {
    whatsappLink: 'whatsapp://send?text=##link##',
    twitterLink: 'twitter://post?message=##link##',
    messengerLink: 'fb-messenger://share/?app_id=##fb_id##&link=##link##',
};

function getDestination() {
    return Odigeo._.get(Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')), 'searchSegments[0].destination.city');
}

function getPassengerName(profile) {
    return Odigeo._.compact(Odigeo._.values(Odigeo._.pick(profile, ['name', 'firstLastName', 'secondLastName']))).join(' ');
}

function setFacebookId() {
    SOCIAL_LINK.messengerLink = SOCIAL_LINK.messengerLink.replace('##fb_id##', Odigeo.SessionScope.social.facebookAppId);
}

module.exports = {
    defaultPassenger: '',
    deeplink: '',

    getEmailParameters: function() {
        return {
            templateId: SHARE_EMAIL_TEMPLATE,
            defaultPassenger: this.defaultPassenger,
            emailTemplateParams: {
                destination: getDestination(),
                deeplink: this.deeplink,
            },
        };
    },

    setPassengerParameters: function(user) {
        var profile = Odigeo._.get(user, 'traveller[0].profile');

        if (!Odigeo._.isEmpty(profile)) {
            this.defaultPassenger = getPassengerName(profile);
        }
    },

    setDeeplinkParameters: function(options) {
        this.deeplink = Dynpack.getPath({
            pageParams: UTM_PARAMS,
            searchParams: Odigeo._.get(options, 'searchParams', ''),
            page: Odigeo._.get(options, 'page'),
            tabProduct: options.tabProduct,
        });
    },

    hasUtmDeeplink: function() {
        return Odigeo._.get(Odigeo.Utils.decodeParams(window.location.search), 'utm_term') === SHARE_EMAIL_UTM;
    },

    trackEventZeroResults: function() {
        if (this.hasUtmDeeplink()) {
            trackingUtils.trackEvent('share_results', 'flight_not_found');
        }
    },

    getSocialNetworkLink: function() {
        setFacebookId();
        return Odigeo._.mapValues(SOCIAL_LINK, function(link) {
            return link.replace('##link##', encodeURIComponent(this.deeplink));
        }, this);
    },
};
